import { FC, forwardRef } from 'react';
import { Tooltip } from 'antd';
import { TooltipProps } from 'antd/lib/tooltip';
import getPopupContainer from '../../Hooks/getPopupContainer';

const ProTooltip: FC<TooltipProps &
  React.RefAttributes<HTMLElement>> = forwardRef<any, TooltipProps>(
  (props, ref) => {
    const { children, ...resProps } = props;
    return (
      <Tooltip ref={ref} getPopupContainer={getPopupContainer} {...resProps}>
        {children}
      </Tooltip>
    );
  },
);

export default ProTooltip;
